import {
  Error,
  GetOneSupAccountWithMain,
  DeleteOneSupAccount,
  InsertOneSupAccount,
  UpdateOneSupAccount,
  GetAllSubuserAccount
} from "../type";
const initialState = {
  SupAccounts: [],
  CreateSupAccounts: [],
  DeleteAccounts: [],
  UpdateAccounts: [],
  OneAccount: [],
  SupAccountsAccType: [],
  loading: false,
};
const SupAccountR = (state = initialState, action) => {
  switch (action.type) {
    case GetAllSubuserAccount:
      return {
        ...state,
        SupAccounts: action.payload,
        loading: false,
      };
    case InsertOneSupAccount:
      return {
        CreateSupAccounts: action.payload,
        loading: false,
      };
      case GetOneSupAccountWithMain:
        return {
          ...state,
          OneAccount: action.payload,
          loading: false,
        }; 
    case UpdateOneSupAccount:
      return {
        UpdateAccounts: action.payload,
        loading: false,
      };
    case DeleteOneSupAccount:
      return {
        DeleteAccounts: action.payload,
        loading: false,

      };

    case Error:
      return {
        loading: false,
        SupAccounts: action.payload,
      };
    default:
      return state;
  }
};
export default SupAccountR;
